import { cn } from "@/lib/utils";
import { panelAtom } from "@/stores/atoms/panel-atom";
import { useAtomValue } from "jotai";
import React from "react";

interface BottomFixedProps {
  children: React.ReactNode;
  className?: string;
}

const BottomFixed = ({ children, className }: BottomFixedProps) => {
  const panelExpanded = useAtomValue(panelAtom);
  return (
    <div
      className={cn(
        "fixed bottom-0 right-0 z-20 p-4 md:p-6 shadow-2xl shadow-black lg:h-[85px] border-t",
        className,
        panelExpanded ? "left-0 sm:left-64" : "left-0 sm:left-16",
      )}
    >
      {children}
    </div>
  );
};

export default BottomFixed;
